import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const SECTIONS = [
  {
    title: "Titolare del trattamento",
    body: "Birban Sas — P.IVA 01385370539, con sede in Via Martiri della Niccioleta 13, 58022 Follonica (GR). Per qualsiasi richiesta relativa alla privacy puoi contattarci al +39 370 374 1644.",
  },
  {
    title: "Quali dati raccogliamo",
    body: "Questo sito non archivia dati personali sui propri server. Il modulo di prenotazione genera un messaggio sul tuo dispositivo e lo apre in WhatsApp: solo se decidi di inviarlo, i dati inseriti (data, orario, numero di persone, note) vengono trattati da WhatsApp/Meta secondo la sua informativa. Le prenotazioni online sono gestite da Avatable, che agisce secondo la propria informativa privacy.",
  },
  {
    title: "Servizi di terze parti",
    body: "Il sito utilizza Google Fonts per i caratteri e incorpora una mappa di Google Maps, che viene caricata solo dopo una tua azione esplicita. Con il tuo consenso viene attivato anche il pixel di Meta (Facebook), usato per misurare l'interesse verso le prenotazioni. I link a Instagram, Facebook, John Bistecchino e Like Follonica rimandano a siti esterni con proprie informative. L'hosting e le statistiche tecniche aggregate sono gestiti dalla piattaforma che ospita il sito.",
  },
  {
    title: "Cookie",
    body: "Utilizziamo cookie tecnici e di preferenza (ad esempio per ricordare il tuo consenso). Solo con il tuo consenso usiamo Google Analytics 4 (Google Ireland Ltd.) per statistiche aggregate sulle visite: gli indirizzi IP non vengono salvati da Google Analytics 4. Il pixel di Meta (finalità pubblicitarie) segue la stessa regola. Puoi cambiare o revocare il consenso in qualsiasi momento da \"Preferenze cookie\" nel piè di pagina. Raccogliamo inoltre statistiche di visita interne in forma aggregata e anonima (numero di visite, provenienza, tipo di dispositivo e lingua del browser), senza cookie e senza alcun dato che permetta di identificarti.",
  },
  {
    title: "I tuoi diritti",
    body: "Puoi chiedere in qualsiasi momento accesso, rettifica, cancellazione o limitazione del trattamento dei tuoi dati scrivendo al Titolare ai contatti sopra indicati. Hai inoltre diritto di reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
  },
];

const PrivacyPolicy = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener("jt-open-privacy", show);
    return () => window.removeEventListener("jt-open-privacy", show);
  }, []);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          data-testid="privacy-modal"
          className="fixed inset-0 z-[70] bg-[#0D0C0B]/97 backdrop-blur-md flex items-center justify-center p-4 sm:p-10"
          onClick={() => setOpen(false)}
        >
          <button
            data-testid="privacy-close"
            onClick={() => setOpen(false)}
            className="absolute top-5 right-5 text-[#F7F4EE] hover:text-[#C5A059] transition-colors p-2"
            aria-label="Chiudi"
          >
            <X size={26} strokeWidth={1.5} />
          </button>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            data-lenis-prevent
            className="max-w-2xl w-full max-h-[80vh] overflow-y-auto border border-[#C5A059]/25 bg-[#1C1917] p-8 sm:p-12"
            onClick={(e) => e.stopPropagation()}
          >
            <span className="text-[10px] uppercase tracking-[0.3em] text-[#C5A059]">
              John Tartarino · Follonica
            </span>
            <h2 className="mt-3 font-display text-3xl text-[#F7F4EE]">
              Privacy &amp; Cookie Policy
            </h2>
            <div className="mt-8 space-y-7">
              {SECTIONS.map((s) => (
                <div key={s.title}>
                  <h3 className="font-display text-lg text-[#C5A059]">{s.title}</h3>
                  <p className="mt-2 text-sm text-[#C5BCAD] leading-relaxed">{s.body}</p>
                </div>
              ))}
            </div>
            <p className="mt-8 text-xs text-[#C5BCAD]/60">
              Ultimo aggiornamento: settembre 2026
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PrivacyPolicy;
